import React, { useEffect } from "react";
import useTypeDecription from "../../../hooks/useTypeDecription";
import LinkQrWrapper from "../linkPage/LinkQrWrapper";
import AmazonIcon from "./svg/AmazonIcon";
import { useSelector } from "react-redux";

export default function AmazonPage() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepTwo.amazon
  );
  const { content, getContent } = useTypeDecription();

  useEffect(() => {
    getContent("amazon");
  }, []);

  return (
    <LinkQrWrapper
      prefixIcon={<AmazonIcon />}
      fieldPlaceholder={lang[0]}
      popoverText={lang[1]}
    >
      {content}
    </LinkQrWrapper>
  );
}
